<script setup lang="ts">
import {
    NotificationSequenceMessage,
    NotificationSequenceMessageInstance,
    NotificationSequenceMessageInstanceStatus,
} from "@/notification-sequences/interfaces/NotificationSequence";
import NotificationSequenceInstanceService from "@/notification-sequences/services/NotificationSequenceInstanceService";
import Icon from "@/core/components/icon/Icon.vue";
import dateHelper from "../../../core/helpers/dateHelper";

defineProps<{
    message: NotificationSequenceMessage;
    instanceMessage?: NotificationSequenceMessageInstance;
}>();
</script>

<template>
  <div>
    <p v-if="!instanceMessage">
      -
    </p>
    <p v-else-if="NotificationSequenceInstanceService.successStatus().includes(instanceMessage.status)">
      <v-tooltip>
        <template #activator="{ props }">
          <Icon name="mdi-check" color="green" v-bind="props" />
        </template>
        <p v-if="instanceMessage.sent_at">
          Message envoyé le {{ dateHelper.mediumFormat(instanceMessage.sent_at) }}
        </p>
      </v-tooltip>
    </p>
    <p v-else-if="NotificationSequenceInstanceService.errorStatus().includes(instanceMessage.status)">
      <v-tooltip>
        <template #activator="{props}">
          <Icon name="mdi-close" color="red" v-bind="props" />
        </template>
        <p v-if="instanceMessage?.status === NotificationSequenceMessageInstanceStatus.NO_CREDIT">
          Message annulé faute de crédits SMS
          <span v-if="instanceMessage?.updated_at">({{ dateHelper.mediumFormat(instanceMessage.updated_at) }})</span>
        </p>
        <p v-else>
          Une erreur est survenue lors de l'envoi du message
          <span v-if="instanceMessage?.updated_at">({{ dateHelper.mediumFormat(instanceMessage.updated_at) }})</span>
        </p>
      </v-tooltip>
    </p>
    <p v-else-if="NotificationSequenceInstanceService.warningStatus().includes(instanceMessage.status)">
      <v-tooltip>
        <template #activator="{props}">
          <Icon name="mdi-alert" color="orange" v-bind="props" />
        </template>
        <p v-if="instanceMessage?.status === NotificationSequenceMessageInstanceStatus.NO_VALID_PHONE">
          Aucun numéro de téléphone valide n'est associé à ce patient
        </p>
        <p v-if="instanceMessage?.status === NotificationSequenceMessageInstanceStatus.SKIPPED">
          Le message a été ignoré car le message a été prévu hors des jours d'envoi autorisés
        </p>
        <p v-if="instanceMessage?.status === NotificationSequenceMessageInstanceStatus.NO_CREDIT">
          Non envoyé : crédits SMS insuffisants. Ce message ne sera pas renvoyé, la suite de la séquence reste programmée.
        </p>
      </v-tooltip>
    </p>
  </div>
</template>

<style scoped>

</style>
